/** Get content type based on file type
 * @param content The content item
 * @returns {string} The content type
 */
export function getContentType(fileType: string): string {
    if (!fileType) {
        return 'image';
    }
    const type = fileType.toLowerCase();
    if (type.includes('video') || type.includes('webm')) {
        return 'video';
    } else if (type.includes('image')) {
        return 'image';
    } else {
        return 'image';
    }
}
